import { Box, Text, Grid } from '@stitch-fix/mode-react';
import { type CloudinaryImageFields, CloudinaryImageWrapper } from '../CloudinaryImageWrapper';
import styles from './style.module.scss';
export type ImageTestimonialsProps = {
  title?: string;
  description?: string;
  testimonials: {
    title: string;
    quote: string;
    label: string;
    source: string;
    image: CloudinaryImageFields;
  }[];
};
export const ImageTestimonials = ({
  title,
  description,
  testimonials
}: ImageTestimonialsProps) => <Box as="section" p="0 1rem" style={{
  textAlign: 'center'
}}>
    {title && <Text setting="title-large" as="h2" mb={0.5}>
        {title}
      </Text>}
    {description && <Box maxWidth="38.625rem" p="0 1rem" m="0 auto 1.5rem">
        <Text as="p" setting="body-small">
          {description}
        </Text>
      </Box>}

    <Box maxWidth={{
    md: '580px',
    lg: '1136px'
  }} m="0 auto" style={{
    display: 'flex',
    justifyContent: 'center'
  }}>
      <Grid
    // Switch to a 2x2 layout when having 4 items on large screens
    columns={{
      sm: 1,
      lg: testimonials.length < 4 ? testimonials.length : 2,
      xl: testimonials.length
    }}
    // Having spacing with 3 or less items improves responsiveness
    spacing={testimonials.length < 4 ? 'standard' : 'none'}>
        {testimonials.map(testimonial => <Box m={{
        sm: '2rem auto 0',
        md: '0 auto'
      }} key={testimonial.source} maxWidth="284px">
            <Box className={styles['image-container']} m="0 auto" style={{
          height: testimonial.title ? '410px' : ''
        }}>
              <CloudinaryImageWrapper src={testimonial.image.src} alt={testimonial.image.alt} lazy sources={{
            sm: 284
          }} cloudinaryAsset={testimonial.image.cloudinaryAsset} sizes={[{
            minWidth: 0,
            fluidWidth: 100
          }, {
            minWidth: 300,
            staticWidth: 284
          }]} imageProps={{
            loading: 'lazy'
          }} />
            </Box>

            <Box mt={-4.2} p="5.2rem 1.5rem 1.4rem">
              {testimonial.title && <Text setting="title-xsmall" as="h3" spacingBottom>
                  {testimonial.title}
                </Text>}
              <blockquote style={{
            margin: 0
          }}>
                <Box mb={1}>
                  <Text as="p" setting="body-small" className={styles['quote-text']}>
                    {testimonial.quote}
                  </Text>
                </Box>
                <Box>
                  <Text family="medium" height="short" scale="1" mr={0.5} align="center" color="gray-35" as="span">
                    {testimonial.label.toUpperCase()}
                  </Text>
                  <Text family="medium" height="short" scale="3">
                    {testimonial.source}
                  </Text>
                </Box>
              </blockquote>
            </Box>
          </Box>)}
      </Grid>
    </Box>
  </Box>;